const ListItem = () => ({
  /**
   * Whether mouse movement is enabled
   * @type {boolean}
   */
  enableMouseMove: false,

  item: {
    ['@mouseenter']() {
      if (!this.enableMouseMove || !this.$refs.image) {
        return;
      }

      this.image = this.$refs.image.content.cloneNode(true).firstElementChild;
      document.body.appendChild(this.image);
    },
    ['@mouseleave']() {
      if (!this.enableMouseMove || !this.image) {
        return;
      }

      document.body.removeChild(this.image);
    },
    ['@mousemove'](ev) {
      if (!this.enableMouseMove || !this.image) {
        return;
      }

      this.image.style.left = `${ev.pageX}px`;
      this.image.style.top = `${ev.pageY}px`;
    }
  },

  /**
   * Pointer change event handler
   * @see {https://developer.mozilla.org/en-US/docs/Web/CSS/@media/pointer}
   * @param {boolean} isFine Whether the primary input mechanism is an accurate pointing device, e.g. a mouse
   * @returns {void}
   */
  onPointerChange(isFine) {
    this.enableMouseMove = isFine;
  },

  init() {
    const mq = window.matchMedia('(pointer: fine)');
    mq.addEventListener('change', ({ matches }) =>
      this.onPointerChange(matches)
    );
    this.onPointerChange(mq.matches);
  }
});

export default ListItem;
